import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { createRequestError } from '@onhandtech/onhand-fe-shared/lib/request'
import type { AxiosError } from 'axios'
import type { SignupCodeDetailsResponse } from 'contracts/api/v4/signup-codes/signup-codes-details.service'

import { signupCodesDetailsSetDataSaga } from './sagas/signup-codes-details-set-data.saga'
import { handleSuccess } from './handle-success'
import type {
  NormalisedCombinedSignupCodeDetails,
  NormalisedSignupCodeDetails,
} from './signup-codes-details.module.types'
import { moduleName } from './signup-codes-details.module.types'

const args: RequestArgs<SignupCodeDetailsResponse, NormalisedSignupCodeDetails> = {
  url: '', // We will override this on demand, based on the code selected
  method: 'GET',
  handleFailure: (e: AxiosError) => createRequestError(e, moduleName),
  handleSuccess,
}

const signupCodesDetailsModule = () =>
  createReduxServiceModule<
    SignupCodeDetailsResponse,
    NormalisedSignupCodeDetails,
    any,
    any,
    NormalisedCombinedSignupCodeDetails
  >({
    moduleName,
    args,
    sagas: {
      onSetDataSaga: signupCodesDetailsSetDataSaga,
    },
  })

export default signupCodesDetailsModule
